// Configs
import config from '../config/index'

// Libs
import { getItem } from './localStorage'

/**
 * Get the popin opening status from localStorage
 * @return {String|false} know popin status or false
 */
export const getPopinStatusFromLocalStorage = assistantId => {
  // Retrieve the popin status from localStorage
  const popinStatus = getItem(`popin_status_${assistantId}`, config.POPIN_STATUS.CLOSED)
  const availablePopinStatus = Object.values(config.POPIN_STATUS)

  // If the popin status exists
  if (availablePopinStatus.includes(popinStatus)) {
    return popinStatus
  }

  return false
}

/**
 * Check if the Chat windows is closed
 * @param {String} assistantId
 * @returns {Boolean}
 */
export const isWindowClosed = assistantId => {
  const status = getPopinStatusFromLocalStorage(assistantId)
  return !status || status === config.POPIN_STATUS.CLOSED
}
